import { apiPost } from '@/shared/utils/requestBuilder';

import type {
  IntimacaoSentencaRegistrada,
  RegistrarIntimacaoSentencaArgs,
} from '../../types/registroIntimacaoSentenca';
import { handleError, unwrapData } from '../services';

export const registroIntimacaoSentencaService = {
  registrar: async ({
    processoId,
    parteArbitralId,
    input,
  }: RegistrarIntimacaoSentencaArgs): Promise<IntimacaoSentencaRegistrada> => {
    const response = await apiPost(
      `/admin/arbitral/processos/${encodeURIComponent(processoId)}/partes/${encodeURIComponent(parteArbitralId)}/intimacao-sentenca/registrar`,
      input,
    );
    // `ErroHttp` com o `code` do core: as recusas são distinguidas pelo código, e não pelo texto,
    // que carrega ids e é diagnóstico.
    if (!response.ok) await handleError(response, 'Erro ao registrar a intimação da sentença');
    return unwrapData<IntimacaoSentencaRegistrada>((await response.json()) as unknown);
  },
};
